import styled from 'styled-components';

import { rem } from '../../../core';

export const ErrorMessageStyled = styled.span`
  color: ${(props) => props.theme.status.danger};
  font-size: ${rem(12)};
  display: block;
  margin-top: ${rem(7)};
`;
